var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientModal3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{stroke:#707070;opacity:0;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10327 4258)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-10327 -4258)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.339,13.82l-1.471-1.513a.316.316,0,0,0-.234-.1h0a.3.3,0,0,0-.234.1L16.2,22.58l-3.711-3.711a.323.323,0,0,0-.468,0l-1.488,1.488a.333.333,0,0,0,0,.476l4.681,4.681a1.48,1.48,0,0,0,.978.476,1.551,1.551,0,0,0,.97-.46h.008L28.348,14.3A.357.357,0,0,0,28.339,13.82Z",
    transform: "translate(-10334.435 -4265.206)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientModal3);
export default __webpack_public_path__ + "static/media/clientModal3.8f0451aa1eb475bc42cd4a366cccf852.svg";
export { ForwardRef as ReactComponent };